const replaceDotWithComma = (incomingData: string) => {
  return incomingData?.replace('.', ',');
};

export const formatInterestRate = (interestRate: any) => {
  return replaceDotWithComma(interestRate?.toFixed(2));
};
